import {en} from 'vuetify/src/locale'
export default {
  $vuetify: en,

  'action': 'Action',
  'alert': 'System alert',
  'network.online': 'Network reconnected',
  'network.offline': 'Network disconnected',
  'oauth.login': 'Continue with {service}',
}